var _g, _path, _g2, _path2, _g3, _path3, _g4, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 135,
    viewBox: "0 0 340 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333 41.6053V107.105C333 114.951 327.353 121.478 319.901 122.843C321.462 121.014 322.276 119.131 322.276 117.207C322.276 99.7358 255.06 85.5724 172.145 85.5724C89.2294 85.5724 22.0132 99.7358 22.0132 117.207C22.0132 119.223 22.9077 121.194 24.6178 123.105H23C14.1635 123.105 7 115.942 7 107.105V41.6053V40.5329H7.06167C9.45978 19.7076 81.4918 3 170 3C258.508 3 330.54 19.7076 332.938 40.5329H333V41.6053Z",
    fill: "url(#paint0_linear_0_1)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 326,
    height: 121
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333 41.6053V107.105C333 114.951 327.353 121.478 319.901 122.843C321.462 121.014 322.276 119.131 322.276 117.207C322.276 99.7358 255.06 85.5724 172.145 85.5724C89.2294 85.5724 22.0132 99.7358 22.0132 117.207C22.0132 119.223 22.9077 121.194 24.6178 123.105H23C14.1635 123.105 7 115.942 7 107.105V41.6053V40.5329H7.06167C9.45978 19.7076 81.4918 3 170 3C258.508 3 330.54 19.7076 332.938 40.5329H333V41.6053Z",
    fill: "url(#paint1_linear_0_1)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 170,
    cy: 115.599,
    rx: 160.855,
    ry: 42.8947,
    fill: "#2E2E2E",
    fillOpacity: 0.01
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 326,
    height: 121
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333 41.6053V107.105C333 114.124 328.481 120.087 322.194 122.243C319.542 108.428 253.378 97.3684 172.145 97.3684C89.2876 97.3684 22.1075 108.875 22.0133 123.075C13.6363 122.566 7 115.61 7 107.105V41.6053V40.5329H7.06167C9.45978 19.7076 81.4918 3 170 3C258.508 3 330.54 19.7076 332.938 40.5329H333V41.6053Z",
    fill: "url(#paint2_linear_0_1)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.831 112.642C332.253 110.014 333 107.246 333 104.339C333 81.5371 260.022 63.0526 170 63.0526C79.9776 63.0526 7 81.5371 7 104.339C7 107.246 7.74675 110.014 9.16876 112.642C11.3573 90.4326 82.5261 72.6002 170 72.6002C257.474 72.6002 328.643 90.4326 330.831 112.642Z",
    fill: "#FCD016"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.831 112.642C332.253 110.014 333 107.246 333 104.339C333 81.5371 260.022 63.0526 170 63.0526C79.9776 63.0526 7 81.5371 7 104.339C7 107.246 7.74675 110.014 9.16876 112.642C11.3573 90.4326 82.5261 72.6002 170 72.6002C257.474 72.6002 328.643 90.4326 330.831 112.642Z",
    fill: "#FCD016"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M330.723 115.544C332.221 113.295 333 110.985 333 108.628C333 85.8266 260.022 67.3421 170 67.3421C79.9776 67.3421 7 85.8266 7 108.628C7 110.985 7.77944 113.295 9.27659 115.544C9.1705 114.931 9.11689 114.315 9.11689 113.696C9.11689 90.9994 81.1467 72.6002 170 72.6002C258.853 72.6002 330.883 90.9994 330.883 113.696C330.883 114.315 330.83 114.931 330.723 115.544Z",
    fill: "#DF8A40"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_1",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 3,
    width: 326,
    height: 121
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333 41.6053V107.105C333 114.124 328.481 120.087 322.194 122.243C319.542 108.428 253.378 97.3684 172.145 97.3684C89.2876 97.3684 22.1075 108.875 22.0133 123.075C13.6363 122.566 7 115.61 7 107.105V41.6053V40.5329H7.06167C9.45978 19.7076 81.4918 3 170 3C258.508 3 330.54 19.7076 332.938 40.5329H333V41.6053Z",
    fill: "url(#paint3_linear_0_1)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_1)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.947 59.0238C334.388 56.3951 335.145 53.6273 335.145 50.7204C335.145 27.9187 261.207 9.43421 170 9.43421C78.7931 9.43421 4.85529 27.9187 4.85529 50.7204C4.85529 53.6273 5.61186 56.3951 7.05259 59.0238C9.26996 36.8142 81.3751 18.9818 170 18.9818C258.625 18.9818 330.73 36.8142 332.947 59.0238Z",
    fill: "#FCD016"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.947 59.0238C334.388 56.3951 335.145 53.6273 335.145 50.7204C335.145 27.9187 261.207 9.43421 170 9.43421C78.7931 9.43421 4.85529 27.9187 4.85529 50.7204C4.85529 53.6273 5.61186 56.3951 7.05259 59.0238C9.26996 36.8142 81.3751 18.9818 170 18.9818C258.625 18.9818 330.73 36.8142 332.947 59.0238Z",
    fill: "#FCD016"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M332.838 61.9253C334.355 59.6767 335.145 57.3663 335.145 55.0099C335.145 32.2081 261.207 13.7237 170 13.7237C78.7931 13.7237 4.85529 32.2081 4.85529 55.0099C4.85529 57.3664 5.64499 59.6767 7.16184 61.9254C7.05435 61.3129 7.00003 60.6969 7.00003 60.0777C7.00003 37.381 79.9776 18.9818 170 18.9818C260.022 18.9818 333 37.381 333 60.0777C333 60.6969 332.946 61.3128 332.838 61.9253Z",
    fill: "#DF8A40"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M252.096 94.8796C251.9 95.1754 251.694 95.4604 251.478 95.7345L251.552 95.783C251.719 95.4773 251.9 95.1759 252.096 94.8796Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M108.994 100.883C109.252 101.132 109.518 101.369 109.79 101.592L109.729 101.655C109.497 101.39 109.252 101.133 108.994 100.883Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_0_1",
    x: 0,
    y: 0,
    width: 340,
    height: 134.105,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_0_1",
    result: "effect2_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_0_1",
    x: 9.14471,
    y: 72.7039,
    width: 321.711,
    height: 86.7895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.309804 0 0 0 0 0.572549 0 0 0 0 0.737255 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_0_1",
    x: 7,
    y: 63.0526,
    width: 326,
    height: 51.5896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_0_1",
    x: 6,
    y: 63.0526,
    width: 328,
    height: 51.5896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_0_1",
    x: 3.85529,
    y: 9.43421,
    width: 332.289,
    height: 53.5896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.530042 0 0 0 0 0.530042 0 0 0 0 0.530042 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_0_1",
    x: 3.85529,
    y: 9.43421,
    width: 332.289,
    height: 51.5896,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1",
    x1: 7,
    y1: 123.105,
    x2: 333,
    y2: 123.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0526316,
    stopColor: "#23447B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259868,
    stopColor: "#2A5599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515624,
    stopColor: "#3868BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759868,
    stopColor: "#2A54A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944079,
    stopColor: "#244B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336E92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1",
    x1: 7,
    y1: 123.105,
    x2: 333,
    y2: 123.105,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0526316,
    stopColor: "#23447B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259868,
    stopColor: "#2A5599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515624,
    stopColor: "#3868BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759868,
    stopColor: "#2A54A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944079,
    stopColor: "#244B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336E92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1",
    x1: 7,
    y1: 123.075,
    x2: 333,
    y2: 123.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0526316,
    stopColor: "#23447B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259868,
    stopColor: "#2A5599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515624,
    stopColor: "#3868BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759868,
    stopColor: "#2A54A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944079,
    stopColor: "#244B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336E92"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1",
    x1: 7,
    y1: 123.075,
    x2: 333,
    y2: 123.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#427997"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0526316,
    stopColor: "#23447B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.259868,
    stopColor: "#2A5599"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515624,
    stopColor: "#3868BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.759868,
    stopColor: "#2A54A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944079,
    stopColor: "#244B84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#336E92"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.94b90dc53f392bc48b134d8fcf0be5fa.svg";
export { ForwardRef as ReactComponent };